import {COLLECTION_USER} from '../users';

/** Subcollection name under users for quiz session documents. */
export const SUBCOLLECTION_SESSIONS = 'sessions';
export const getCollectionQuizSession = (uid: string) => `${COLLECTION_USER}/${uid}/${SUBCOLLECTION_SESSIONS}`;
